module.exports = __webpack_public_path__ + "media/images/category/accommodation-c15d7779266266d46849f70f675c6538.svg";